import { Box, Heading, Grid, GridItem, Text } from '@chakra-ui/react';
import ImageShimmer from '../ImageShimmer/ImageShimmer';
import { PrimaryButton, TextWithArrowButton } from './Button';
import ColoredSquares from './ColoredSquares';

export default function LargeCard({
  card,
  index,
  length,
}: {
  card: {
    image: {
      sourceUrl: string;
      altText: string;
    };
    title: string;
    text: string;
    button?: {
      type: string;
      text: {
        strong: string;
        normal: string;
      };
      url: string;
      target?: string;
    };
  };
  index: number;
  length: number;
}) {
  return (
    <Box position="relative" minH={{ lg: '100%' }}>
      <ImageShimmer
        src={card.image.sourceUrl}
        alt={card.image.altText}
        width="480"
        height="280"
        style={{ objectFit: 'contain' }}
        layout="intrinsic"
      />
      <Box mt="12" h={{ xl: '100%' }} display={{ xl: 'flex' }} alignItems={{ xl: 'center' }}>
        <Box>
          <ColoredSquares />
          <Heading
            as="h3"
            mt={{ base: '6', lg: '8' }}
            fontSize={{ base: '1.75rem', lg: '2rem' }}
            lineHeight={{ base: '2rem', lg: '2.25rem' }}
          >
            {card.title}
          </Heading>
          <Text mt="6">{card.text}</Text>
          {card.button && card.button.url && (
            <>
              {card.button.type === 'primary' && (
                <PrimaryButton href={card.button.url} mt={{ base: '10', lg: '8' }}>
                  {card.button.text.strong}
                </PrimaryButton>
              )}
              {card.button.type === 'text-with-arrow' && (
                <TextWithArrowButton
                  type="light"
                  href={card.button.url}
                  text={{
                    strong: card.button.text.strong,
                    normal: card.button.text.normal,
                  }}
                  mt={{ base: '10', lg: '8' }}
                />
              )}
            </>
          )}
        </Box>
      </Box>
      {!(length - 1 === index) && length < 3 && (
        <Box
          position="absolute"
          left={{ base: '0', lg: 'auto' }}
          right={{ base: '0', lg: '-3.4375rem', xl: '-6.875rem' }}
          ml={{ base: 'auto' }}
          mr={{ base: 'auto', lg: '0' }}
          bottom={{ base: '-3rem', lg: '0' }}
          w={{ base: '100%', lg: '0.0625rem' }}
          h={{ base: '0.0625rem', lg: '100%' }}
          bgColor="grey.300"
        />
      )}
    </Box>
  );
}
